import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Grabber = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 11.5C9.67157 11.5 9 12.1716 9 13C9 13.8284 9.67157 14.5 10.5 14.5C11.3284 14.5 12 13.8284 12 13C12 12.1716 11.3284 11.5 10.5 11.5ZM10.5 6.5C9.67157 6.5 9 7.17157 9 8C9 8.82843 9.67157 9.5 10.5 9.5C11.3284 9.5 12 8.82843 12 8C12 7.17157 11.3284 6.5 10.5 6.5ZM9 3C9 2.17157 9.67157 1.5 10.5 1.5C11.3284 1.5 12 2.17157 12 3C12 3.82843 11.3284 4.5 10.5 4.5C9.67157 4.5 9 3.82843 9 3ZM5.5 11.5C4.67157 11.5 4 12.1716 4 13C4 13.8284 4.67157 14.5 5.5 14.5C6.32843 14.5 7 13.8284 7 13C7 12.1716 6.32843 11.5 5.5 11.5ZM5.5 6.5C4.67157 6.5 4 7.17157 4 8C4 8.82843 4.67157 9.5 5.5 9.5C6.32843 9.5 7 8.82843 7 8C7 7.17157 6.32843 6.5 5.5 6.5ZM4 3C4 2.17157 4.67157 1.5 5.5 1.5C6.32843 1.5 7 2.17157 7 3C7 3.82843 6.32843 4.5 5.5 4.5C4.67157 4.5 4 3.82843 4 3Z"
      />
    </svg>
  )
})

export default Grabber
